export var INTAKE_CHIP_PROPS = {
  open: {
    caption: 'Open',
    color: 'positive'
  },
  open_conditionally: {
    caption: 'Open',
    color: 'positive'
  },
  closed: {
    caption: 'Closed',
    color: 'neutral'
  },
  closed_conditionally: {
    caption: 'Closed',
    color: 'neutral'
  },
  likely_open: {
    caption: 'Likely open',
    color: 'warning'
  },
  will_open: {
    caption: 'Will open',
    color: 'positive'
  },
  will_open_conditionally: {
    caption: 'Will open',
    color: 'positive'
  },
  waitlist: {
    caption: 'Waitlist',
    color: 'warning'
  }
};
export var NO_DATA_AVAILABLE = 'No data available';